import { Menu } from "antd";
import { Link, NavLink, useLocation } from "react-router-dom";
import LogoImage from "../../assets/images/eats-tots-logo.svg";
import DashboardIcon from "../../assets/images/icon/dashbord-icons.svg";
import UserManagerIcon from "../../assets/images/icon/user-management-icons.svg";
import ProductsManagerIcon from "../../assets/images/icon/products-manager-icons.svg";
import PostManagerIcon from "../../assets/images/icon/post-manager-icons.svg";
import {
  AppstoreOutlined,
  ClockCircleOutlined,
  MailOutlined,
  PercentageOutlined,
  DollarOutlined,
  TagsOutlined,
  AuditOutlined,
} from "@ant-design/icons";

import lang from "../../helper/lang";

function Sidenav({ color }) {
  const { pathname } = useLocation();
  const page = pathname.replace(/^\//, "").split("/")[0] || "dashboard";

  const menuItems = [
    {
      key: "dashboard",
      label: (
        <NavLink to="/dashboard">
          <span
            className="icon"
            style={{ background: page === "dashboard" ? color : "" }}
          >
            <img src={DashboardIcon} alt="" />
          </span>
          <span className="label">{lang("Dashboard")}</span>
        </NavLink>
      ),
    },
    {
      key: "user-manager",
      label: (
        <NavLink to="/user-manager">
          <span
            className="icon"
            style={{ background: page === "user-manager" ? color : "" }}
          >
            <img src={UserManagerIcon} alt="" />
          </span>
          <span className="label">{lang("User Manager")}</span>
        </NavLink>
      ),
    },
    {
      key: "trial-users",
      label: (
        <NavLink to="/trial-users">
          <span
            className="icon"
            style={{ background: page === "trial-users" ? color : "" }}
          >
            <ClockCircleOutlined />
          </span>
          <span className="label">Trial Users</span>
        </NavLink>
      ),
    },
    {
      key: "billing-logs",
      label: (
        <NavLink to="/billing-logs">
          <span
            className="icon"
            style={{ background: page === "billing-logs" ? color : "" }}
          >
            <DollarOutlined />
          </span>
          <span className="label">Billing Logs</span>
        </NavLink>
      ),
    },
    {
      key: "custom-ingredients",
      label: (
        <NavLink to="/custom-ingredients">
          <span
            className="icon"
            style={{ background: page === "custom-ingredients" ? color : "" }}
          >
            <img src={ProductsManagerIcon} alt="" />
          </span>
          <span className="label">{lang("Custom Ingredient Manager")}</span>
        </NavLink>
      ),
    },
    {
      key: "ingredient-categories",
      label: (
        <NavLink to="/ingredient-categories">
          <span
            className="icon"
            style={{
              background: page === "ingredient-categories" ? color : "",
            }}
          >
            <AppstoreOutlined />
          </span>
          <span className="label">Ingredient Category Manager</span>
        </NavLink>
      ),
    },

    {
      key: "discount-codes",
      label: (
        <NavLink to="/discount-codes">
          <span
            className="icon"
            style={{ background: page === "discount-codes" ? color : "" }}
          >
            <PercentageOutlined />
          </span>
          <span className="label">Discount Codes</span>
        </NavLink>
      ),
    },
    {
      key: "subscription-plans",
      label: (
        <NavLink to="/subscription-plans">
          <span
            className="icon"
            style={{ background: page === "subscription-plans" ? color : "" }}
          >
            <TagsOutlined />
          </span>
          <span className="label">Subscription Plans</span>
        </NavLink>
      ),
    },
    {
      key: "waitlist-manager",
      label: (
        <NavLink to="/waitlist-manager">
          <span
            className="icon"
            style={{ background: page === "waitlist-manager" ? color : "" }}
          >
            <ClockCircleOutlined />
          </span>
          <span className="label">Waitlist Manager</span>
        </NavLink>
      ),
    },
    // {
    //   key: "audit-logs",
    //   label: (
    //     <NavLink to="/audit-logs">
    //       <span
    //         className="icon"
    //         style={{ background: page === "audit-logs" ? color : "" }}
    //       >
    //         <AuditOutlined />
    //       </span>
    //       <span className="label">Audit Logs</span>
    //     </NavLink>
    //   ),
    // },
    {
      key: "content-manager",
      label: (
        <NavLink to="/content-manager">
          <span
            className="icon"
            style={{ background: page === "content-manager" ? color : "" }}
          >
            <img src={PostManagerIcon} alt="" />
          </span>
          <span className="label">{lang("Content Manager")}</span>
        </NavLink>
      ),
    },
    {
      key: "email-templates",
      label: (
        <NavLink to="/email-templates">
          <span
            className="icon"
            style={{ background: page === "email-templates" ? color : "" }}
          >
            <MailOutlined />
          </span>
          <span className="label">{lang("Email Templates")}</span>
        </NavLink>
      ),
    },
  ];

  return (
    <>
      <div className="brand">
        <Link to="/dashboard">
          <div className="tabLogo d-flex align-items-center justify-content-center">
            <img
              src={LogoImage}
              alt="Eatstoats"
              style={{ marginRight: "8px" }}
            />
          </div>
        </Link>
      </div>
      <hr />
      <Menu
        theme="light"
        mode="inline"
        selectedKeys={[page]}
        items={menuItems}
      />
    </>
  );
}

export default Sidenav;
